// WorkOrder constants — single source of truth for status enum, label, and Tag color
// see: app/models/work_order.rb (aasm column: :status)
import { useTranslation } from 'react-i18next'

export const WORK_ORDER_STATUSES = [
  'draft',
  'out_of_stock',
  'allocated',
  'processing',
  'completed',
  'canceled',
] as const

export type WorkOrderStatus = typeof WORK_ORDER_STATUSES[number]

export function useWorkOrderStatusLabel() {
  const { t } = useTranslation()
  return (status: string | undefined | null): string => {
    if (!status) return ''
    switch (status as WorkOrderStatus) {
      case 'draft':        return t('enums.work_order_status.draft')
      case 'out_of_stock': return t('enums.work_order_status.out_of_stock')
      case 'allocated':    return t('enums.work_order_status.allocated')
      case 'processing':   return t('enums.work_order_status.processing')
      case 'completed':    return t('enums.work_order_status.completed')
      case 'canceled':     return t('enums.work_order_status.canceled')
      default:             return status
    }
  }
}

// Tag color mapping — 依 docs/guidelines/WEB_VISUAL_DESIGN.md §C 全域語義色：
// - draft / canceled 用 default，「初始 / 已取消」
// - allocated / completed 用 success，「配貨完成 / 全單完成」
// - processing 用 processing，「正在揀貨 / 加工」
// - out_of_stock 用 error，「庫存不足、需 retry_allocation 才能繼續」
const WORK_ORDER_STATUS_COLORS_STRICT = {
  draft: 'default',
  out_of_stock: 'error',
  allocated: 'success',
  processing: 'processing',
  completed: 'success',
  canceled: 'default',
} satisfies Record<WorkOrderStatus, string>

export const WORK_ORDER_STATUS_COLORS: Record<string, string> = WORK_ORDER_STATUS_COLORS_STRICT
